import { cn } from "@/lib/utils";
import { Loader } from "../Loader";
import {
  Button,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  Dialog as DialogWrapper,
} from "../ui";
import { X } from "lucide-react";
import { FC } from "react";
import { DialogProps } from "./types";

const Dialog: FC<DialogProps> = ({
  open,
  setOpen,
  onSave,
  children,
  title,
  triggerChildren,
  hideFooter = false,
  saveText = "Save changes",
  cancelText = "Cancel",
  saveBtnClassName = "",
  cancelBtnClassName = "",
  isLoading = false,
  contentClassName = "",
  bodyClassName = "",
  hideClose
}) => {
  return (
    <DialogWrapper open={open} onOpenChange={setOpen}>
      {triggerChildren && (
        <DialogTrigger asChild>{triggerChildren}</DialogTrigger>
      )}
      <DialogContent
        className={cn(contentClassName ? contentClassName : "sm:max-w-[425px]")}
        onPointerDownOutside={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <div className="flex items-center justify-between">
            <DialogTitle>{title}</DialogTitle>
            {hideClose ? <></> :<DialogClose asChild>
              <Button
                type="button"
                variant="ghost"
                // onClick={onCloseClick}
                className="rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none"
              >
                <X className="h-5 w-5 stroke-[5px]" />
              </Button>
            </DialogClose>}
          </div>
        </DialogHeader>
        <div className={cn("my-3 max-h-[500px] overflow-hidden overflow-y-auto lg:h-auto p-3 lg:pt-3", bodyClassName)}>
          {children}
        </div>
        {!hideFooter && (
          <DialogFooter>
            <DialogClose asChild>
              <Button
                type="button"
                variant="outline"
                className={cancelBtnClassName}
                disabled={isLoading}
              >
                {cancelText}
              </Button>
            </DialogClose>
            {onSave ? (
              <Button
                type="button"
                className={saveBtnClassName}
                onClick={onSave}
                disabled={isLoading}
              >
                {isLoading && <Loader variant="secondary" />} {saveText}
              </Button>
            ) : (
              <></>
            )}
          </DialogFooter>
        )}
      </DialogContent>
    </DialogWrapper>
  );
};

export default Dialog;
